import {Component} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {mergeMap} from 'rxjs/operators';

import {CredentialsService} from 'app/login/services/credentials.service';
import {LoginService} from 'app/login/services/login.service';
import {NavService} from 'shared/nav/nav.service';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

@Component({
  selector: 'password-set-page',
  templateUrl: 'password-set-page.html',
  styleUrls: ['password-set-page.scss'],
})
export class PasswordSetPage extends DefaultPage {

  public oldPassword: string = '';
  public newPassword: string = '';
  public newPasswordRepeat: string = '';
  public showPassword: boolean = false;

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private loginService: LoginService,
    private credentialsService: CredentialsService,
    private alertCtrl: AlertController,
  ) { 
    super(navService);
  }

  public get isValid(): boolean {
    if (this.oldPassword.length <= 0) {
      return false;
    }
    if (this.newPassword.length <= 0) {
      return false;
    }
    if (this.newPassword !== this.newPasswordRepeat) {
      return false;
    }

    return true;
  }

  public onChangeClick(): void {
    if (this.isValid) {
      this.changePassword();
    }
  }

  private changePassword(): void {
    const newPassword: string = this.newPassword;

    this.loginService.changePassword(this.oldPassword, this.newPassword).subscribe(
      (success) => {
        this.showSuccessAlert();
        this.credentialsService.getCredentials().subscribe((credentials) => {
          return this.credentialsService.saveCredentials(credentials.username, newPassword);
        });
      },
      (error) => {this.showErrorAlert(); },
    );
  }

  private showSuccessAlert(): void {

    this.translateService.get([
      'PROFILE.CHANGE_PASSWORD',
      'PROFILE.CHANGE_PASSWORD_SUCCESS_MESSAGE',
      'COMMON.OK',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['PROFILE.CHANGE_PASSWORD'];
      const message: string = translations['PROFILE.CHANGE_PASSWORD_SUCCESS_MESSAGE'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        header: titleLabel,
        message: message,
        cssClass: 'regular-alert',
        buttons: [
          {
            text: okLabel,
            handler: (): void => {
              this.navService.pop();
            },
          },
        ],
      });
      alert.present();
    });
  }

  private showErrorAlert(): void {

    this.translateService.get([
      'COMMON.ERROR',
      'PROFILE.CHANGE_PASSWORD_ERROR_MESSAGE',
      'COMMON.OK',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['COMMON.ERROR'];
      const message: string = translations['PROFILE.CHANGE_PASSWORD_ERROR_MESSAGE'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        header: titleLabel,
        message: message,
        cssClass: 'regular-alert',
        buttons: [
          {
            text: okLabel,
          },
        ],
      });
      alert.present();
    });
  }
}
